/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, createStyles, Divider, Grid, InputAdornment, makeStyles, TextField, Theme, Typography } from '@material-ui/core';
import { FormApi } from 'final-form';
import React, { useEffect, useState } from 'react';
import { AnyObject, Field, Form, FormSpy } from 'react-final-form';
import { client } from '../..';
import { showNotification } from '../../App';
import { CollapsibleSectionCard } from '../../components/cards/CollapsibleSectionCard';
import { SkeletonLoader } from '../../components/loading/SkeletonLoader';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';
import { useCurrencySymbol } from '../../hooks/useCurrencySymbol';

const SECTION_COLOR = '#b45309';
const SECTION_BG = '#fffbeb';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            flex: 1,
            flexFlow: 'column',
            maxWidth: '800px',
        },
        textField: {
            width: '100%',
            maxWidth: '75px',
        },
        actionsRow: {
            display: 'flex',
            justifyContent: 'flex-end',
            gap: theme.spacing(1.5),
            marginTop: theme.spacing(3),
        },
        actionsDivider: {
            marginTop: theme.spacing(3),
        },
        heading: {
            fontSize: theme.typography.pxToRem(15),
            fontWeight: 600,
            color: theme.palette.primary.main
        },
    })
);

interface FormState {
    redIndicatorWhenActualVsBudgetIsLessThanPercentage: number | null;
    amberIndicatorWhenActualVsBudgetIsLessThanPercentage: number | null;
    redIndicatorWhenNinetyDayDebtExceedsPercentage: number | null;
    redIndicatorWhenNinetyDayUnbilledFeesExceedsPercentage: number | null;
    redIndicatorWhenNinetyDayUnbilledDisbursementsExceedsPercentage: number | null;
    firmOverallStandardChargeOutRate: number | null;
    currentBankOverdraftInterestRate: number | null;
    firmStandardTradingTermsInDays: number | null;
    firmTargetWipLockupDays: number | null;
    firmOverallBlendedCostRate: number | null;
}
interface FinancialThresholdsTabState {
    isLoading: boolean;
    isFormChanged: boolean;
    onSubmitLoading: boolean;
}

export default function FinancialThresholdsTab() {

    const classes = useStyles();

    const [state, setState] = useState<FinancialThresholdsTabState>({
        isLoading: true,
        isFormChanged: false,
        onSubmitLoading: false,
    });

    const [formState, setFormState] = useState<FormState>({
        redIndicatorWhenActualVsBudgetIsLessThanPercentage: null,
        amberIndicatorWhenActualVsBudgetIsLessThanPercentage: null,
        redIndicatorWhenNinetyDayDebtExceedsPercentage: null,
        redIndicatorWhenNinetyDayUnbilledFeesExceedsPercentage: null,
        redIndicatorWhenNinetyDayUnbilledDisbursementsExceedsPercentage: null,
        firmOverallStandardChargeOutRate: null,
        currentBankOverdraftInterestRate: null,
        firmStandardTradingTermsInDays: null,
        firmTargetWipLockupDays: null,
        firmOverallBlendedCostRate: null
    });

    const currencyQuery = useCurrencySymbol();

    const financialThresholdsQuery = useQuery<FinancialThresholdsData>(FinancialThresholdsQuery);

    useEffect(() => {

        if (financialThresholdsQuery.data && !financialThresholdsQuery.error && !financialThresholdsQuery.loading) {

            const { 

                amberIndicatorWhenActualVsBudgetIsLessThanPercentage,
                currentBankOverdraftInterestRate,
                firmOverallStandardChargeOutRate,
                firmStandardTradingTermsInDays,
                firmTargetWipLockupDays,
                redIndicatorWhenActualVsBudgetIsLessThanPercentage,
                redIndicatorWhenNinetyDayDebtExceedsPercentage,
                redIndicatorWhenNinetyDayUnbilledDisbursementsExceedsPercentage,
                redIndicatorWhenNinetyDayUnbilledFeesExceedsPercentage,
                showGreenIndicator,
                firmOverallBlendedCostRate

            } = financialThresholdsQuery.data.settings.systems.financialThresholdsSettings.config;

            setFormState((prevState) => {
                return {
                    ...prevState,
                    amberIndicatorWhenActualVsBudgetIsLessThanPercentage,
                    currentBankOverdraftInterestRate,
                    firmOverallStandardChargeOutRate,
                    firmStandardTradingTermsInDays,
                    firmTargetWipLockupDays: firmTargetWipLockupDays,
                    redIndicatorWhenActualVsBudgetIsLessThanPercentage,
                    redIndicatorWhenNinetyDayDebtExceedsPercentage,
                    redIndicatorWhenNinetyDayUnbilledDisbursementsExceedsPercentage,
                    redIndicatorWhenNinetyDayUnbilledFeesExceedsPercentage,
                    showGreenIndicator,
                    firmOverallBlendedCostRate
                };
            });

            setState((prevState) => {
                return {
                    ...prevState,
                    isLoading: false
                };
            });
        }

    }, [financialThresholdsQuery.data, financialThresholdsQuery.error, financialThresholdsQuery.loading]);

    // const onTextFieldChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     const value = event.target.value;
    //     const name = event.target.name;

    //     setState((prevState) => {
    //         return {
    //             ...prevState,
    //             [name]: value
    //         };
    //     });
        
    // };

    // tslint:disable-next-line: no-any
    const onFormValueChanged = (changeProps: any) => {
        if (!changeProps.pristine) {
            setState((prevState) => {
                return {
                    ...prevState,
                    isFormChanged: true
                };
            });
        }
    };

    // tslint:disable-next-line: no-any
    // const required = (value: any) => {
    //     return value ? undefined : 'Required';
    // };

    const onReset = (form: FormApi<FormState>) => () => {
        form.setConfig('keepDirtyOnReinitialize', false);
        form.batch(() => {
            form.reset();
        });
        form.setConfig('keepDirtyOnReinitialize', true);
    };

    const onSubmit = (form: FormApi<FormState>, values: AnyObject) => {

        setState((_prevState) => {
            return {
                ..._prevState,
                onSubmitLoading: true
            };
        });

        client
            .mutate<FinancialThresholdsMutationData, FinancialThresholdsMutationParams>({
                mutation: FinancialThresholdsMutation,
                variables: {
                    amberIndicatorWhenActualVsBudgetIsLessThanPercentage: values.amberIndicatorWhenActualVsBudgetIsLessThanPercentage,
                    currentBankOverdraftInterestRate: values.currentBankOverdraftInterestRate,
                    firmOverallStandardChargeOutRate: values.firmOverallStandardChargeOutRate,
                    firmStandardTradingTermsInDays: values.firmStandardTradingTermsInDays,
                    firmTargetWipLockupDays: values.firmTargetWipLockupDays,
                    redIndicatorWhenActualVsBudgetIsLessThanPercentage: values.redIndicatorWhenActualVsBudgetIsLessThanPercentage,
                    redIndicatorWhenNinetyDayDebtExceedsPercentage: values.redIndicatorWhenNinetyDayDebtExceedsPercentage,
                    redIndicatorWhenNinetyDayUnbilledDisbursementsExceedsPercentage: values.redIndicatorWhenNinetyDayUnbilledDisbursementsExceedsPercentage,
                    redIndicatorWhenNinetyDayUnbilledFeesExceedsPercentage: values.redIndicatorWhenNinetyDayUnbilledFeesExceedsPercentage,
                    showGreenIndicator: values.showGreenIndicator,
                    firmOverallBlendedCostRate: values.firmOverallBlendedCostRate
                },
            })
            // tslint:disable-next-line: no-any
            .then((results) => {
                if (results.data?.settings.financialThresholdsSettings.update.status) {
                    showNotification(null, 'Successfully submitted', 'info');   
                    
                    onReset(form);

                    setState((_prevState) => {
                        return {
                            ..._prevState,
                            onSubmitLoading: false
                        };
                    });  
                }
            })
            // tslint:disable-next-line:no-any
            .catch((reason: any) => {
                showNotification('Failed to update firm details', reason, 'error');
                setState((_prevState) => {
                    return {
                        ..._prevState,
                        onSubmitLoading: false
                    };
                });
            });
    };

    const redAmberAndGreenComponent = () => {
        return (
            <CollapsibleSectionCard
                title="Red/Amber/Green"
                icon={AttachMoneyIcon}
                color={SECTION_COLOR}
                bgColor={SECTION_BG}
            >
                    <Grid container={true} spacing={3}>
                        <Grid item={true} xs={12} md={12}>
                            <Box
                                display="flex"
                                gridGap="10px"
                            >
                                <Typography>
                                    Display a red indicator when actual vs budget is less than
                                </Typography>
                                <Field
                                    name="redIndicatorWhenActualVsBudgetIsLessThanPercentage"
                                    // validate={required}
                                >
                                    {({ input, meta }) => (
                                        <TextField
                                            {...input}
                                            className={classes.textField}
                                            name="redIndicatorWhenActualVsBudgetIsLessThanPercentage"
                                            error={meta.error && meta.touched}
                                            helperText={
                                                meta.error &&
                                                meta.touched
                                                    ? 'Required'
                                                    : ''
                                            }
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment 
                                                        position="start"
                                                        style={{
                                                            // marginLeft: '5px'
                                                        }}
                                                    >
                                                        %
                                                    </InputAdornment>
                                                ),
                                            }}
                                            inputProps={{
                                                style: { textAlign: 'right' }
                                            }}
                                            type="number"
                                            size="small"
                                        />
                                    )}
                                </Field>
                            </Box>
                        </Grid>
                        <Grid item={true} xs={12} md={12}>
                            <Box
                                display="flex"
                                gridGap="10px"
                            >
                                <Typography>
                                    Display an amber indicator when actual vs budget is less than
                                </Typography>
                                <Field
                                    name="amberIndicatorWhenActualVsBudgetIsLessThanPercentage"
                                    // validate={required}
                                >
                                    {({ input, meta }) => (
                                        <TextField
                                            {...input}
                                            className={classes.textField}
                                            name="amberIndicatorWhenActualVsBudgetIsLessThanPercentage"
                                            error={meta.error && meta.touched}
                                            helperText={
                                                meta.error &&
                                                meta.touched
                                                    ? 'Required'
                                                    : ''
                                            }
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment 
                                                        position="start"
                                                        style={{
                                                            // marginLeft: '5px'
                                                        }}
                                                    >
                                                        %
                                                    </InputAdornment>
                                                ),
                                            }}
                                            inputProps={{
                                                style: { textAlign: 'right' }
                                            }}
                                            type="number"
                                            size="small"
                                        />
                                    )}
                                </Field>
                            </Box>
                        </Grid>
                        <Grid item={true} xs={12} md={12}>
                            <Typography>
                                Otherwise display green
                            </Typography>
                        </Grid>
                    </Grid>
            </CollapsibleSectionCard>
        );
    };

    const exceptionsComponent = () => {
        return (
            <CollapsibleSectionCard
                title="Exceptions"
                icon={AttachMoneyIcon}
                color={SECTION_COLOR}
                bgColor={SECTION_BG}
            >
                    <Grid container={true} spacing={3}>
                        <Grid item={true} xs={12} md={12}>
                            <Box
                                display="flex"
                                gridGap="10px"
                            >
                                <Typography>
                                    Display red when 90 day debt exceeds
                                </Typography>
                                <Field
                                    name="redIndicatorWhenNinetyDayDebtExceedsPercentage"
                                    // validate={required}
                                >
                                    {({ input, meta }) => (
                                        <TextField
                                            {...input}
                                            className={classes.textField}
                                            name="redIndicatorWhenNinetyDayDebtExceedsPercentage"
                                            error={meta.error && meta.touched}
                                            helperText={
                                                meta.error &&
                                                meta.touched
                                                    ? 'Required'
                                                    : ''
                                            }
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment 
                                                        position="start"
                                                        style={{
                                                            // marginLeft: '5px'
                                                        }}
                                                    >
                                                        %
                                                    </InputAdornment>
                                                ),
                                            }}
                                            inputProps={{
                                                style: { textAlign: 'right' }
                                            }}
                                            type="number"
                                            size="small"
                                        />
                                    )}
                                </Field>
                                <Typography>
                                    of total debt
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item={true} xs={12} md={12}>
                            <Box
                                display="flex"
                                gridGap="10px"
                            >
                                <Typography>
                                    Display red when 90 day unbilled fees exceeds
                                </Typography>
                                <Field
                                    name="redIndicatorWhenNinetyDayUnbilledFeesExceedsPercentage"
                                    // validate={required}
                                >
                                    {({ input, meta }) => (
                                        <TextField
                                            {...input}
                                            className={classes.textField}
                                            name="redIndicatorWhenNinetyDayUnbilledFeesExceedsPercentage"
                                            error={meta.error && meta.touched}
                                            helperText={
                                                meta.error &&
                                                meta.touched
                                                    ? 'Required'
                                                    : ''
                                            }
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment 
                                                        position="start"
                                                        style={{
                                                            // marginLeft: '5px'
                                                        }}
                                                    >
                                                        %
                                                    </InputAdornment>
                                                ),
                                            }}
                                            inputProps={{
                                                style: { textAlign: 'right' }
                                            }}
                                            type="number"
                                            size="small"
                                        />
                                    )}
                                </Field>
                                <Typography>
                                    of total unbilled fees
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item={true} xs={12} md={12}>
                            <Box
                                display="flex"
                                gridGap="10px"
                            >
                                <Typography>
                                    Display red when 90 day unbilled disbursements exceeds
                                </Typography>
                                <Field
                                    name="redIndicatorWhenNinetyDayUnbilledDisbursementsExceedsPercentage"
                                    // validate={required}
                                >
                                    {({ input, meta }) => (
                                        <TextField
                                            {...input}
                                            className={classes.textField}
                                            name="redIndicatorWhenNinetyDayUnbilledDisbursementsExceedsPercentage"
                                            error={meta.error && meta.touched}
                                            helperText={
                                                meta.error &&
                                                meta.touched
                                                    ? 'Required'
                                                    : ''
                                            }
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment 
                                                        position="start"
                                                        style={{
                                                            // marginLeft: '5px'
                                                        }}
                                                    >
                                                        %
                                                    </InputAdornment>
                                                ),
                                            }}
                                            inputProps={{
                                                style: { textAlign: 'right' }
                                            }}
                                            type="number"
                                            size="small"
                                        />
                                    )}
                                </Field>
                                <Typography>
                                    of total unbilled disbursements
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
            </CollapsibleSectionCard>
        );
    };

    const standardsComponent = () => {
        return (
            <CollapsibleSectionCard
                title="Standards"
                icon={AttachMoneyIcon}
                color={SECTION_COLOR}
                bgColor={SECTION_BG}
            >
                    <Grid container={true} spacing={3}>
                        <Grid item={true} xs={12} md={12}>
                            <Box
                                display="flex"
                                gridGap="10px"
                            >
                                <Typography>
                                    Firm Overall Standard Blended Charge Out Rate
                                </Typography>
                                <Field
                                    name="firmOverallStandardChargeOutRate"
                                    // validate={required}
                                >
                                    {({ input, meta }) => (
                                        <TextField
                                            {...input}
                                            className={classes.textField}
                                            name="firmOverallStandardChargeOutRate"
                                            error={meta.error && meta.touched}
                                            helperText={
                                                meta.error &&
                                                meta.touched
                                                    ? 'Required'
                                                    : ''
                                            }
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment 
                                                        position="start"
                                                        style={{
                                                            // marginLeft: '5px'
                                                        }}
                                                    >
                                                        {currencyQuery.data?.options.currencySymbol.symbol || '$'}
                                                    </InputAdornment>
                                                ),
                                            }}
                                            inputProps={{
                                                style: { textAlign: 'right' }
                                            }}
                                            type="number"
                                            size="small"
                                        />
                                    )}
                                </Field>
                            </Box>
                        </Grid>
                        <Grid item={true} xs={12} md={12}>
                            <Box
                                display="flex"
                                gridGap="10px"
                            >
                                <Typography>
                                    Firm's Overall Blended Cost Rate
                                </Typography>
                                <Field
                                    name="firmOverallBlendedCostRate"
                                    // validate={required}
                                >
                                    {({ input, meta }) => (
                                        <TextField
                                            {...input}
                                            className={classes.textField}
                                            name="firmOverallBlendedCostRate"
                                            error={meta.error && meta.touched}
                                            helperText={
                                                meta.error &&
                                                meta.touched
                                                    ? 'Required'
                                                    : ''
                                            }
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment 
                                                        position="start"
                                                        style={{
                                                            // marginLeft: '5px'
                                                        }}
                                                    >
                                                        {currencyQuery.data?.options.currencySymbol.symbol || '$'}
                                                    </InputAdornment>
                                                ),
                                            }}
                                            inputProps={{
                                                style: { textAlign: 'right' }
                                            }}
                                            type="number"
                                            size="small"
                                        />
                                    )}
                                </Field>
                            </Box>
                        </Grid>
                        <Grid item={true} xs={12} md={12}>
                            <Box
                                display="flex"
                                gridGap="10px"
                            >
                                <Typography>
                                    Current Bank Overdraft Interest Rate 
                                </Typography>
                                <Field
                                    name="currentBankOverdraftInterestRate"
                                    // validate={required}
                                >
                                    {({ input, meta }) => (
                                        <TextField
                                            {...input}
                                            className={classes.textField}
                                            name="currentBankOverdraftInterestRate"
                                            error={meta.error && meta.touched}
                                            helperText={
                                                meta.error &&
                                                meta.touched
                                                    ? 'Required'
                                                    : ''
                                            }
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment 
                                                        position="start"
                                                        style={{
                                                            // marginLeft: '5px'
                                                        }}
                                                    >
                                                        %
                                                    </InputAdornment>
                                                ),
                                            }}
                                            inputProps={{
                                                style: { textAlign: 'right' }
                                            }}
                                            type="number"
                                            size="small"
                                        />
                                    )}
                                </Field>
                            </Box>
                        </Grid>
                        <Grid item={true} xs={12} md={12}>
                            <Box
                                display="flex"
                                gridGap="10px"
                            >
                                <Typography>
                                    Firm's target debtor days
                                </Typography>
                                <Field
                                    name="firmStandardTradingTermsInDays"
                                    // validate={required}
                                >
                                    {({ input, meta }) => (
                                        <TextField
                                            {...input}
                                            className={classes.textField}
                                            name="firmStandardTradingTermsInDays"
                                            error={meta.error && meta.touched}
                                            helperText={
                                                meta.error &&
                                                meta.touched
                                                    ? 'Required'
                                                    : ''
                                            }
                                            type="number"
                                            size="small"
                                        />
                                    )}
                                </Field>
                            </Box>
                        </Grid>
                        <Grid item={true} xs={12} md={12}>
                            <Box
                                display="flex"
                                gridGap="10px"
                            >
                                <Typography>
                                    Firm's target WIP Lockup days
                                </Typography>
                                <Field
                                    name="firmTargetWipLockupDays"
                                    // validate={required}
                                >
                                    {({ input, meta }) => (
                                        <TextField
                                            {...input}
                                            className={classes.textField}
                                            name="firmTargetWipLockupDays"
                                            error={meta.error && meta.touched}
                                            helperText={
                                                meta.error &&
                                                meta.touched
                                                    ? 'Required'
                                                    : ''
                                            }
                                            type="number"
                                            size="small"
                                        />
                                    )}
                                </Field>
                            </Box>
                        </Grid>
                    </Grid>
            </CollapsibleSectionCard>
        );
    };

    return (
        <div className={classes.root}>
            {state.isLoading || currencyQuery.loading ? (
                <SkeletonLoader variant="form" rows={10} columns={1} />
            ) : (
                <Form
                    onSubmit={(values, form: FormApi<FormState>) => onSubmit(form, values)}  
                    initialValues={formState}
                    initialValuesEqual={() => true}
                    keepDirtyOnReinitialize={true}
                    subscription={{
                        submitting: true,
                        pristine: true,
                    }}
                    render={({
                        handleSubmit,
                        form,
                        submitting,
                        pristine,
                    }) => {
                        return (
                            
                            <form onSubmit={handleSubmit}>
                                <FormSpy 
                                    subscription={{ pristine: true }}
                                    // tslint:disable-next-line: no-shadowed-variable
                                    onChange={props => {
                                        onFormValueChanged(props);
                                    }}
                                />
                                
                                <Grid container={true} spacing={3}>

                                    <Grid item={true} xs={12} md={12}>
                                        {redAmberAndGreenComponent()}
                                    </Grid>
                                    <Grid item={true} xs={12} md={12}>
                                        {exceptionsComponent()}
                                    </Grid>
                                    <Grid item={true} xs={12} md={12}>
                                        {standardsComponent()}
                                    </Grid>
                                    {/* {printJson(values)} */}
                                </Grid>
                                <Divider className={classes.actionsDivider} />
                                <div className={classes.actionsRow}>
                                    <Button
                                        variant="text"
                                        color="default"
                                        type="button"
                                        disabled={submitting || pristine}
                                        onClick={onReset(form)}
                                    >
                                        Reset
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        type="submit"
                                        disabled={submitting || pristine || state.onSubmitLoading}
                                    >
                                        Save
                                    </Button>
                                </div>
                            </form>
                        );
                    }}
                />
            )}
        </div>
    );
}

// tslint:disable-next-line: no-any
export function printJson(values: any) {
    if (values) {
        return (
            <>
                <pre>
                    {JSON.stringify(values, undefined, 2)}
                </pre>
            </>
        );
    } else {
        return (
            <>
                <FormSpy subscription={{ values: true }}>
                    {/* tslint:disable-next-line: no-shadowed-variable */}
                    {({ values }) => (
                        <pre>
                            {JSON.stringify(values, undefined, 2)}
                            {/* <RenderCount /> */}
                        </pre>
                    )}
                </FormSpy>
            </>
        );
    }
}

type FinancialThresholdsData = {
    settings: Settings;
}

type Settings = {
    id:         number;
    systems:    Systems;
    __typename: string;
}

type Systems = {
    financialThresholdsSettings: FinancialThresholdsSettings;
    __typename:                  string;
}

type FinancialThresholdsSettings = {
    id:         number;
    config:     Config;
    __typename: string;
}

type Config = {
    id:                                                              number | null;
    redIndicatorWhenActualVsBudgetIsLessThanPercentage:              number | null;
    amberIndicatorWhenActualVsBudgetIsLessThanPercentage:            number | null;
    redIndicatorWhenNinetyDayDebtExceedsPercentage:                  number | null;
    redIndicatorWhenNinetyDayUnbilledFeesExceedsPercentage:          number | null;
    redIndicatorWhenNinetyDayUnbilledDisbursementsExceedsPercentage: number | null;
    firmOverallStandardChargeOutRate:                                number | null;
    currentBankOverdraftInterestRate:                                number | null;
    firmStandardTradingTermsInDays:                                  number | null;
    firmTargetWipLockupDays:                                         number | null;
    showGreenIndicator:                                              boolean;
    firmOverallBlendedCostRate:                                      number | null;
    __typename:                                                      string;
}

const FinancialThresholdsQuery = gql`
    query financialThresholdsSettings {
        settings {
            id
            systems {
                financialThresholdsSettings {
                    id
                    config {
                        id
                        redIndicatorWhenActualVsBudgetIsLessThanPercentage
                        amberIndicatorWhenActualVsBudgetIsLessThanPercentage
                        redIndicatorWhenNinetyDayDebtExceedsPercentage
                        redIndicatorWhenNinetyDayUnbilledFeesExceedsPercentage
                        redIndicatorWhenNinetyDayUnbilledDisbursementsExceedsPercentage
                        firmOverallStandardChargeOutRate
                        currentBankOverdraftInterestRate
                        firmStandardTradingTermsInDays
                        firmTargetWipLockupDays
                        showGreenIndicator
                        firmOverallBlendedCostRate
                        __typename
                    }
                    __typename
                }
                __typename
            }
            __typename
        }
    }

`;

type FinancialThresholdsMutationParams = {
    redIndicatorWhenActualVsBudgetIsLessThanPercentage: number;
    amberIndicatorWhenActualVsBudgetIsLessThanPercentage: number;
    redIndicatorWhenNinetyDayDebtExceedsPercentage: number;
    redIndicatorWhenNinetyDayUnbilledFeesExceedsPercentage: number;
    redIndicatorWhenNinetyDayUnbilledDisbursementsExceedsPercentage: number;
    firmOverallStandardChargeOutRate: number;
    currentBankOverdraftInterestRate: number;
    firmStandardTradingTermsInDays: number;
    firmTargetWipLockupDays: number;
    showGreenIndicator: boolean;
    firmOverallBlendedCostRate: number;
}

type FinancialThresholdsMutationData = {
    settings: FinancialThresholdsMutationSettings;
}

type FinancialThresholdsMutationSettings = {
    financialThresholdsSettings: FinancialThresholdsMutationFinancialSettings;
    __typename:                  string;
}

type FinancialThresholdsMutationFinancialSettings = {
    update:     Update;
    __typename: string;
}

type Update = {
    status:     boolean;
    error:      null;
    __typename: string;
}


const FinancialThresholdsMutation = gql`
    mutation FinancialThresholdsMutation(
        $redIndicatorWhenActualVsBudgetIsLessThanPercentage: Decimal
        $amberIndicatorWhenActualVsBudgetIsLessThanPercentage: Decimal
        $redIndicatorWhenNinetyDayDebtExceedsPercentage: Decimal
        $redIndicatorWhenNinetyDayUnbilledFeesExceedsPercentage: Decimal
        $redIndicatorWhenNinetyDayUnbilledDisbursementsExceedsPercentage: Decimal
        $firmOverallStandardChargeOutRate: Decimal
        $currentBankOverdraftInterestRate: Decimal
        $firmStandardTradingTermsInDays: Int
        $firmTargetWipLockupDays: Int
        $showGreenIndicator: Boolean
        $firmOverallBlendedCostRate: Decimal
    ) {
        settings {
            financialThresholdsSettings{
                update(
                    redIndicatorWhenActualVsBudgetIsLessThanPercentage :$redIndicatorWhenActualVsBudgetIsLessThanPercentage
                    amberIndicatorWhenActualVsBudgetIsLessThanPercentage : $amberIndicatorWhenActualVsBudgetIsLessThanPercentage
                    redIndicatorWhenNinetyDayDebtExceedsPercentage: $redIndicatorWhenNinetyDayDebtExceedsPercentage
                    redIndicatorWhenNinetyDayUnbilledFeesExceedsPercentage: $redIndicatorWhenNinetyDayUnbilledFeesExceedsPercentage
                    redIndicatorWhenNinetyDayUnbilledDisbursementsExceedsPercentage: $redIndicatorWhenNinetyDayUnbilledDisbursementsExceedsPercentage
                    firmOverallStandardChargeOutRate: $firmOverallStandardChargeOutRate
                    currentBankOverdraftInterestRate: $currentBankOverdraftInterestRate
                    firmStandardTradingTermsInDays: $firmStandardTradingTermsInDays
                    firmTargetWipLockupDays: $firmTargetWipLockupDays
                    showGreenIndicator: $showGreenIndicator
                    firmOverallBlendedCostRate: $firmOverallBlendedCostRate
                ) {
                    status
                    error
                    __typename
                }
                __typename
            }
            __typename
        }
    }
`;
